import React, { useEffect, useRef, useState } from "react";
import {
  I2cAlert,
  I2cDataTable
} from "@webcomponents/i2cwebcomponents/dist/react";
function DataTable(props) {
  const {
    setCurrentPage,
    currentPage,
    rowData,
    columnDefs,
    pageSize,
    total,
    tableDataApi,
    noData,
    rowSelection,
    getRowId,
    selectedRowIds = null,
    onSelectionChange,
  } = props;
  const [rowDataa, setRowDataa] = useState(rowData);
  const [gridOptions, setGridOptions] = useState({});
  const [alertMsg, setAlertMsg] = useState("");
  const [alertState, setAlertState] = useState(false);
  const isRestoringSelection = useRef(false);
  const rowDataRef = useRef(rowData);
  const selectedRowIdsRef = useRef(new Set());

  rowDataRef.current = rowDataa;
  selectedRowIdsRef.current = new Set((selectedRowIds ?? []).map((id) => String(id)));

  const css = ` 
    .header-right
      {
        display:flex;
        gap:var(--i2c-spacing-3);
        flex-wrap:wrap;
      }
      
      i2c-data-table{
        max-width: 100%;
        display: block;
        --ag-grid--shadow: 0 0 0;
        --pagination-padding: var(--i2c-spacing-3) 0 
      }
      i2c-section-header{
        --sec-header-padding:var(--i2c-spacing-4) var(--i2c-spacing-6) var(--i2c-spacing-4);
        --sec-header-margin:0;
        --sec-header-parent-space:0;
        --sec-title-container-gap:0.563rem;
      }
      i2c-section-header::part(badge)
      {
        padding-bottom:0.25rem;
      }
      i2c-section-header::part(sec-head-header)
      {
        border:0;
      } 
      i2c-pagination{
        --pagination-padding: var(--i2c-spacing-3) 0  
      }
      `;
  const handleGridApi = async (data) => {
    try {
      const gridApi = await tableDataApi?.current.getGridApi();
      // console.log("tableData", gridApi)
      gridApi.updateGridOptions({ rowData: data });
      restoreSelectedRows(gridApi);
    } catch (error) {
      console.warn('Error getting grid API:', error);
    }
  };

  const getRowKey = (row) => {
    if (!row) return "";
    if (typeof getRowId === "function") return String(getRowId(row));
    return String(row.id ?? row.user_id ?? "");
  };

  const restoreSelectedRows = (gridApi) => {
    if (!gridApi || !onSelectionChange) return;

    isRestoringSelection.current = true;
    gridApi.forEachNode((node) => {
      node.setSelected(selectedRowIdsRef.current.has(getRowKey(node.data)));
    });
    setTimeout(() => {
      isRestoringSelection.current = false;
    }, 0);
  };

  const handleSelectionChanged = (event) => {
    if (isRestoringSelection.current || !onSelectionChange) return;

    onSelectionChange({
      selectedRows: event.api.getSelectedRows(),
      visibleRows: rowDataRef.current,
    });
  };

  useEffect(() => {
    if (props.rowData.length !== 0) {
      setGridOptions({
        columnDefs: columnDefs,
        rowSelection: rowSelection,
        rowData: rowDataa?.length !== 0 ? rowDataa : [],
        ...(onSelectionChange
          ? {
            getRowId: (params) => getRowKey(params.data),
            onFirstDataRendered: (event) => restoreSelectedRows(event.api),
            onRowDataUpdated: (event) => restoreSelectedRows(event.api),
            onSelectionChanged: handleSelectionChanged,
          }
          : {}),
        suppressMoveWhenRowDragging: true,
        suppressMovableColumns: true,
      });
    } else {
      setGridOptions({
        columnDefs: columnDefs,
        rowSelection: rowSelection,
        rowData: false,
        ...(onSelectionChange
          ? {
            getRowId: (params) => getRowKey(params.data),
            onSelectionChanged: handleSelectionChanged,
          }
          : {}),
        suppressMoveWhenRowDragging: true,
        suppressMovableColumns: true,
      });
    }
    handleGridApi(rowDataa)
    // const api = tableDataApi?.current?.getGridApi();
    // console.log("tableData", tableDataApi)
    // if (api) {
    //   api.setRowData && api.setRowData(rowDataa?.length !== 0 ? rowDataa : []);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowDataa]);

  useEffect(() => {
    setRowDataa(rowData.length ? rowData : []);
  }, [rowData]);

  useEffect(() => {
    if (!onSelectionChange) return;

    const restoreCurrentGridSelection = async () => {
      try {
        const gridApi = await tableDataApi?.current?.getGridApi();
        restoreSelectedRows(gridApi);
      } catch (error) {
        console.warn('Error restoring selected rows:', error);
      }
    };

    restoreCurrentGridSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRowIds, onSelectionChange]);

  const handlePageChange = (e) => {
    setCurrentPage &&
      setCurrentPage(e?.target?.tablePagination?.currentPage ?? 1);
  };

  useEffect(() => {
    const tableRef = tableDataApi?.current;
    if (tableRef) {
      tableRef.addEventListener("i2c-page-change", handlePageChange);
      return () => {
        tableRef.removeEventListener("i2c-page-change", handlePageChange);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableDataApi]);

  return (
    <>
      {/* error message starts */}
      <I2cAlert
        open={alertState ? true : false}
        className="alert"
        variant="danger"
        type="plain"
        layout="layoutAsideLeft"
        headerArt="cs-linear-alert-circle"
      >
        <span slot="label">{alertMsg}</span>
      </I2cAlert>
      <I2cDataTable
        id="dataTable1"
        gridOptionInput={gridOptions}
        notFound={noData}
        headerBlock
        gridBorder
        paginationEnable
        currentPage={currentPage ?? 1}
        pageSize={pageSize ?? 6}
        totalCount={total ?? 6}
        ref={tableDataApi}
      ></I2cDataTable>

      {/* <footer slot="footer">
        <I2cButton slot="footer" variant="secondary gray" onClick={closeModal}>
          Cancel
        </I2cButton>
        {rowDataa?.length !== 0 && (
          <I2cButton
            slot="footer"
            variant="primary"
            onClick={() => {
              const api = table.current.getGridApi();
              const selectedNodes = api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              onAssign(selectedRows);
            }}
          >
            Assign
          </I2cButton>
        )}
      </footer> */}
      <style>{css}</style>
    </>
  );
}
export default DataTable;
